import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  EmptyState,
  EmptyStateVariant,
  EmptyStateHeader,
  EmptyStateBody,
  EmptyStateIcon,
} from '@patternfly/react-core';
import { CalendarTimesIcon as EmptyIcon } from '@patternfly/react-icons';

export default function NoClassState() {
  const { t } = useTranslation();

  return (
    <EmptyState variant={EmptyStateVariant.lg}>
      <EmptyStateHeader
        titleText={t('No class available')}
        headingLevel="h4"
        icon={<EmptyStateIcon icon={EmptyIcon} />}
      />
      <EmptyStateBody>
        {t('This live virtual class is not currently available.')}
      </EmptyStateBody>
    </EmptyState>
  );
}
